import dark from './themes/dark.js';
import { getMuiAndStyledThemes } from './muiTheme.js';
export { GlobalAppStyle } from './GlobalAppStyle.js';

var getZignalyThemeExport = function (themeName, overrides) {
    var theme = dark;
    return getMuiAndStyledThemes(theme, overrides);
};

export { getZignalyThemeExport };
